import { ImpersonationAlert } from "@/components";
import { useAllRights } from "@/hooks";
import { useUserContext } from "@/providers";
import { FloatButton, Layout } from "antd";
import { useEffect, useState } from "react";
import { useErrorHandler } from "react-error-boundary";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { Bounce, ToastContainer } from "react-toastify";
import { Navbar } from "./Navbar";
import PageFooter from "./PageFooter";
import SpinLoader from "./SpinLoader";
import { InnerContent } from "./styled";

const { Content } = Layout;

const MainLayout = () => {
  const handleError = useErrorHandler();

  const { userToken } = useUserContext();

  const [authLoading, setAuthLoading] = useState(true);

  const applicationError = useSelector(
    ({ applicationError }) => applicationError.error
  );
  const rights = useAllRights();

  useEffect(() => {
    if (userToken) setAuthLoading(false);
  }, [userToken, rights]);

  useEffect(() => {
    if (!applicationError || !applicationError.response) return;

    let err;

    if (applicationError instanceof Error) {
      err = applicationError;
    } else {
      const message =
        typeof applicationError?.message === "string"
          ? applicationError.message
          : "Unknown error";

      err = new Error(message);

      if (applicationError?.response?.status) {
        err.response = { status: applicationError.response.status };
      }
    }

    handleError(err);
  }, [applicationError, handleError]);

  if (authLoading || !userToken?.token) return <SpinLoader />;

  return (
    <Layout>
      <Navbar />
      <Content>
        <InnerContent>
          <ImpersonationAlert />
          <Outlet />
        </InnerContent>
      </Content>
      <PageFooter />
      <FloatButton.BackTop
        data-test-id="back-to-top-button"
        type="primary"
        visibilityHeight="200"
      />
      <ToastContainer
        transition={Bounce}
        draggable={false}
        position="bottom-right"
        closeOnClick={false}
        toastStyle={{ cursor: "default" }}
        hideProgressBar
      />
    </Layout>
  );
};

export default MainLayout;
